const politicianData = {
  person: {
    title: "Hon.",
    firstName: "Akindele",
    middleName: "Femi",
    lastName: "Olanrewaju",

    fullName: "Hon. Akindele Femi Olanrewaju",

    initials: "AF",

    image: "/images/HON AKINDELE FEMI OLANREWAJU.jpg",

    motto: "PEOPLE • PURPOSE • PROGRESS",
  },

  currentOffice: {
    status: "active",

    position: "Member",

    office: "Ekiti State House of Assembly",

    institution: "Ekiti State House of Assembly",

    institutionLabel: "ASSEMBLY",

    institutionValue: "7th Assembly",

    roleDescription:
      "Representing Irepodun/Ifelodun I Constituency",

    constituency: "Irepodun/Ifelodun I",

    constituencyLabel: "CONSTITUENCY",

    tenure: {
      start: "2023",
      end: "2027",
    },

    location: "Igede-Ekiti, Ekiti State",
  },

  constituency: {
    localGovernment: "Irepodun / Ifelodun",
    constituency: "Irepodun / Ifelodun I",
    ward: "05 — Igede I",
    unit: "01",
    town: "Igede-Ekiti",
    state: "Ekiti State",
  },

  about: {
    title: "Leadership rooted in",
    emphasis: "representation.",

    lead:
      "Hon. Akindele Femi Olanrewaju is a Member of the Ekiti State House of Assembly representing Irepodun/Ifelodun I Constituency.",

    description:
      "Through legislative representation and engagement with constituents, his office provides a platform for bringing community concerns, aspirations and development priorities into the legislative process.",
  },

  careerHistory: [
    {
      position: "Member",
      organization: "Ekiti State House of Assembly",
      description: "Representing Irepodun/Ifelodun I Constituency",
      startYear: 2023,
      endYear: 2027,
      current: true,
    },
  ],

  legislative: [
    {
      number: "01",
      icon: "§",
      title: "Legislation",
      text:
        "Contributing to the legislative process through bills, motions, debates and policy discussions.",
      linkText: "Explore Legislative Work →",
      link: "#legislative",
    },

    {
      number: "02",
      icon: "◎",
      title: "Representation",
      text:
        "Bringing the concerns, interests and aspirations of constituents to the attention of the House.",
      linkText: "Constituency Representation →",
      link: "#constituency",
      featured: true,
    },

    {
      number: "03",
      icon: "◌",
      title: "Oversight",
      text:
        "Participating in the oversight responsibilities of the Ekiti State House of Assembly.",
      linkText: "View Activities →",
      link: "#legislative",
    },
  ],

  projects: [
    {
      tag: "EDUCATION",
      title: "Education & Human Capital Development",
      description:
        "Constituency initiatives and programmes focused on educational development.",
    },

    {
      tag: "HEALTHCARE",
      title: "Healthcare & Community Wellbeing",
      description:
        "Initiatives supporting healthcare access and community wellbeing.",
    },

    {
      tag: "EMPOWERMENT",
      title: "Youth & Community Empowerment",
      description:
        "Programmes designed to create opportunities and strengthen communities.",
    },
  ],

  news: [
    {
      tag: "CONSTITUENCY",
      title: "Community Engagement & Representation",
      imageClass: "",
    },

    {
      tag: "PUBLIC SERVICE",
      title: "Serving the People Through Effective Representation",
      imageClass: "second",
    },
  ],

  featuredNews: {
    label: "LEGISLATIVE UPDATE",
    year: "2026",
    title:
      "Updates from the Office of Hon. Akindele Femi Olanrewaju",
    description:
      "Stay informed about legislative activities, constituency engagements and official updates.",
  },

  contact: {
    email: "office@example.com",
    phone: "+234 XXX XXX XXXX",
  },

  social: {
    facebook: "#facebook",
    instagram: "#instagram",
    youtube: "#youtube",
    x: "#x",
  },
};

export default politicianData;